import { Action } from '@ngrx/store';
import { ProductEsignForm } from '@model';

export enum AgreementActionTypes {
    CreateProductAgreement = "[CreateProductAgreement] create e-signature agreement",
    CreateProductAgreementSuccess = "[CreateProductAgreement] create product e-signature agreement success",
    CreateProductAgreementFail = "[CreateProductAgreement] create product e-signature agreement fail",
    AgreementLinkLoad = '[Agreement] Link Load',
    AgreementLinkLoadSuccess = '[Agreement] Link Load Success',
    AgreementLinkLoadFail = '[Agreement] Link Load Fail',
}

export class CreateProductAgreement implements Action{
    readonly type = AgreementActionTypes.CreateProductAgreement;
    constructor(public payload: ProductEsignForm){}
  }
  
  export class CreateProductAgreementSuccess implements Action {
    readonly type = AgreementActionTypes.CreateProductAgreementSuccess;
    constructor(public payload: number) {}
  }
  
  export class CreateProductAgreementFail implements Action {
    readonly type = AgreementActionTypes.CreateProductAgreementFail;
    constructor(public payload: any) {}
  }

export class AgreementLinkLoad implements Action{
    readonly type = AgreementActionTypes.AgreementLinkLoad;
    constructor(public agreementId: number){}
}

export class AgreementLinkLoadSuccess implements Action{
    readonly type = AgreementActionTypes.AgreementLinkLoadSuccess;
    constructor(public payload: string){}
}

export class AgreementLinkLoadFail implements Action{
    readonly type = AgreementActionTypes.AgreementLinkLoadFail;
    constructor(public payload: any){}
}

export type AgreementActions = 
    | CreateProductAgreement
    | CreateProductAgreementSuccess
    | CreateProductAgreementFail
    | AgreementLinkLoad
    | AgreementLinkLoadSuccess
    | AgreementLinkLoadFail;